import { ClaimingStage, FetchVerificationResponse, VerificationStatus } from '@app/api/models/claiming.models';
import { BusinessUnitCompleteness } from './../../../../api/models/api-models';
import { BusinessData, Establishment } from '@app/api/models/api-models';
import { Action, createReducer, on } from '@ngrx/store';
import * as claimingActions from '@app/features/dashboard/store/actions/claiming/claiming.actions';
import * as businessActions from '@app/features/dashboard/store/actions/business/business.actions';

export interface DashBoardState {
  selectedBusinessUnit: BusinessData;
  establishmentDefault: Establishment;
  selectedEstablishmentId: string;
  completeness: BusinessUnitCompleteness;
  redirectUrl: string;
  isLoading: boolean;
  oauthToken: boolean;
  business: BusinessData[];
  verificationStatus: VerificationStatus;
  retryFetchVerifications: boolean;
  fetchVerificationOptions: FetchVerificationResponse;
  isInitVerificationError: boolean;
  IsCompleteVerificationError: boolean;
  isVerificationProcessing: boolean;
  errorMessage: string;
  reachedMaximumAttempts: boolean;
  wrongVerificationCode: boolean;
  lookupRequested: boolean;
  needsVerification: boolean;
  claimingStage: ClaimingStage;
  openClaimingDialog: boolean;
  checkOwnershipStatus: boolean;
  lookupSuccess: boolean;
  profileValidationErrors: string[];
  didMacUserLookupFailed: boolean;
}

export const initialState: DashBoardState = {
  isLoading: false,
  selectedBusinessUnit: null,
  establishmentDefault: null,
  selectedEstablishmentId: null,
  completeness: null,
  redirectUrl: null,
  oauthToken: null,
  business: [],
  verificationStatus: null,
  retryFetchVerifications: false,
  fetchVerificationOptions: null,
  isInitVerificationError: null,
  IsCompleteVerificationError: false,
  isVerificationProcessing: false,
  errorMessage: null,
  reachedMaximumAttempts: false,
  wrongVerificationCode: false,
  lookupRequested: false,
  needsVerification: false,
  claimingStage: null,
  openClaimingDialog: false,
  checkOwnershipStatus: false,
  lookupSuccess: false,
  profileValidationErrors: [],
  didMacUserLookupFailed: false,
};

export const dashBoardReducer = createReducer(
  initialState,
  on(claimingActions.fetchVerificationOptions, state => ({
    ...state,
    verificationStatus: VerificationStatus.FECTHING_VERI,
    isVerificationProcessing: true,
    IsCompleteVerificationError: false,
    isInitVerificationError: false,
  })),
  on(claimingActions.fetchVerificationOptionsSuccess, (state, payload) => ({
    ...state,
    fetchVerificationOptions: payload.fecthResponse,
    verificationStatus:
      payload.fecthResponse.isPending && !state.retryFetchVerifications ? VerificationStatus.INITIATE_VERI : VerificationStatus.FECTHING_VERI,
    isVerificationProcessing: false,
  })),
  on(claimingActions.fetchVerificationOptionsSuccess, (state, payload) => ({
    ...state,
    fetchVerificationOptions: payload.fecthResponse,
    isVerificationProcessing: false,
  })),
  on(claimingActions.fetchVerificationOptionsFailure, state => ({ ...state, isVerificationProcessing: false })),
  on(claimingActions.initVerification, state => ({
    ...state,
    isInitVerificationError: false,
    verificationStatus: VerificationStatus.INITIATE_VERI,
    isVerificationProcessing: true,
    wrongVerificationCode: false,
    reachedMaximumAttempts: false,
  })),
  on(claimingActions.initVerification, state => ({
    ...state,
    retryFetchVerifications: false,
    isInitVerificationError: false,
    isVerificationProcessing: false,
  })),
  on(claimingActions.initVerificationSuccess, state => ({
    ...state,
    retryFetchVerifications: false,
    isInitVerificationError: false,
    isVerificationProcessing: false,
  })),
  on(claimingActions.initVerificationFailure, state => ({ ...state, isInitVerificationError: true, isVerificationProcessing: false })),
  on(claimingActions.resetInitVerificationError, state => ({
    ...state,
    isInitVerificationError: false,
    wrongVerificationCode: false,
    reachedMaximumAttempts: false,
    verificationStatus: null,
  })),
  on(claimingActions.completeVerification, state => ({
    ...state,
    IsCompleteVerificationError: false,
    isVerificationProcessing: true,
    wrongVerificationCode: false,
    reachedMaximumAttempts: false,
  })),
  on(claimingActions.completeVerificationFailure, state => ({ ...state, IsCompleteVerificationError: true, isVerificationProcessing: false })),
  on(claimingActions.completeVerificationSuccess, state => ({
    ...state,
    IsCompleteVerificationError: false,
    isVerificationProcessing: false,
    verificationStatus: VerificationStatus.FINISH_VERI,
  })),
  on(claimingActions.retryFetchVerification, state => ({ ...state, retryFetchVerifications: true })),
  on(claimingActions.wrongVerificationCodeError, state => ({ ...state, wrongVerificationCode: true, isVerificationProcessing: false })),
  on(claimingActions.maximumAttemptsError, state => ({ ...state, reachedMaximumAttempts: true, isVerificationProcessing: false })),
  on(claimingActions.setLookUpRequest, (state, payload) => ({ ...state, lookupRequested: payload.lookupRequested })),
  on(claimingActions.lookUpRequestSuccess, state => ({ ...state, openClaimingDialog: false, checkOwnershipStatus: false })),
  on(claimingActions.setClaimingStage, (state, payload) => ({
    ...state,
    claimingStage: payload.claimingStage,
    loading: false,
    redirectUrl: payload.redirectUrl,
  })),
  on(claimingActions.closeClaimingDialog, state => ({ ...state, openClaimingDialog: false })),
  on(claimingActions.openClaimingDialog, state => ({ ...state, openClaimingDialog: true })),
  on(claimingActions.checkOwnershipStatus, state => ({ ...state, checkOwnershipStatus: true })),
  on(claimingActions.closeOwnershipStatus, state => ({ ...state, checkOwnershipStatus: false })),
  on(claimingActions.macLookUpRequest, state => ({ ...state, didMacUserLookupFailed: false, isLoading: true, claimingStage: null })),
  on(claimingActions.macLookUpRequestFailure, state => ({ ...state, didMacUserLookupFailed: true, isLoading: false })),
  on(businessActions.getAllBusiness, (state, payload) => ({
    ...state,
    claimingStage: null,
    isLoading: true,
    redirectUrl: null,
    reachedMaximumAttempts: false,
    wrongVerificationCode: false,
    selectedEstablishmentId: payload.selectedEstablishmentId,
  })),
  on(businessActions.getAllBusinessSuccess, (state, payload) => {
    const selectedBusinessUnit = payload.businessList.find(businessUnit => businessUnit.establishmentId === payload.selectedEstablismentId);
    return {
      ...state,
      isLoading: false,
      business: payload.businessList,
      selectedBusinessUnit,
      selectedEstablishmentId: payload.selectedEstablismentId,
    };
  }),
  on(businessActions.deleteGmbListing, state => ({ ...state, isLoading: true })),
  on(businessActions.getCompletenessSuccess, (state, payload) => ({ ...state, completeness: payload.businessCompleteness })),
  on(businessActions.reactivateGMBListingAttempt, state => ({ ...state, claimingStage: null })),
  on(businessActions.reactivateGMBListingFailure, state => ({ ...state, isLoading: false })),
  on(businessActions.errorLayoutShow, state => ({ ...state, isLoading: false })),
  on(businessActions.errorLayoutHide, state => ({ ...state, errorMessage: '' })),
  on(businessActions.setSelectedBusinessUnit, (state, payload) => {
    return { ...state, selectedBusinessUnit: payload.businessData };
  }),
  on(businessActions.validateAddressFailure, (state, payload) => ({ ...state, profileValidationErrors: payload.errorCodes })),
  on(businessActions.validateProfileFailure, (state, payload) => ({ ...state, profileValidationErrors: payload.errorCodes })),
  on(businessActions.validateAddressSuccess, (state, payload) => ({ ...state, profileValidationErrors: payload.errorCodes })),
  on(businessActions.validateProfileSuccess, (state, payload) => ({ ...state, profileValidationErrors: payload.errorCodes }))
);

export function reducer(state: DashBoardState | undefined, action: Action) {
  return dashBoardReducer(state, action);
}
